import React__default from 'react';
import styled from '../../../../../../node_modules/@mui/material/styles/styled.mjs';
import Typography from '../../../../../../node_modules/@mui/material/Typography/Typography.mjs';

const StyledTypography = styled(Typography)(({ theme })=>({
        '& ul': {
            margin: theme.spacing(1, 0, 0)
        }
    }));
const colorToMUIColor = {
    primary: 'primary',
    secondary: 'textSecondary',
    error: 'error'
};
const TypographyCore = ({ align, children, color, component, disabled, variant = 'body1' })=>{
    return /*#__PURE__*/ React__default.createElement(StyledTypography, {
        align: align,
        color: color ? colorToMUIColor[color] : disabled ? 'textSecondary' : undefined,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- typing is complicated
        component: component,
        variant: variant
    }, children);
};

export { TypographyCore };
//# sourceMappingURL=Typography.mjs.map
